import { render, staticRenderFns } from "./add-comment-modal.vue?vue&type=template&id=58df1990&"
import script from "./add-comment-modal.ts?vue&type=script&lang=ts&"
export * from "./add-comment-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports